(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["crack-initiation-landing"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ci-section]').forEach((section) => {
    const mainImage = section.querySelector('.ci-gallery__main');
    const price = section.querySelector('[data-ci-price]');

    section.querySelectorAll('[data-ci-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (!mainImage) return;
        mainImage.src = thumb.dataset.src;
        mainImage.srcset = '';
        mainImage.alt = thumb.dataset.alt || '';
        section.querySelectorAll('[data-ci-thumb]').forEach((item) => item.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });

    section.querySelectorAll('input[name="id"]').forEach((variantInput) => {
      variantInput.addEventListener('change', () => {
        if (price && variantInput.dataset.price) price.textContent = variantInput.dataset.price;
        if (mainImage && variantInput.dataset.image) {
          mainImage.src = variantInput.dataset.image;
          mainImage.srcset = '';
          mainImage.alt = variantInput.dataset.imageAlt || '';
        }
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variantInput.value);
        window.history.replaceState({}, '', url);
      });
    });

    section.querySelectorAll('a[href^="#crack-initiation-form-"]').forEach((link) => {
      link.addEventListener('click', (event) => {
        const form = section.querySelector('.ci-buybox__form');
        if (!form) return;
        event.preventDefault();
        form.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
